import { IconButton } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';

// The back chevron, for AppBar's `leading` on a centred bar.
//
// The composer's plus, as a chevron: the same 44px circle, white with an edge
// here, because the composer's grey all but disappears on the bar's Gardenia
// (1.06:1). First drawn on the calculator's bar; shared once the Care hub's
// pages wanted it too.
const BackChevron = ({
  label,
  onClick,
}: {
  /** What going back does, for a screen reader. */
  label: string;
  onClick: () => void;
}) => (
  <IconButton aria-label={label} onClick={onClick} variant='round'>
    <Icon icon={'chevron-left' as never} fontSize={16} />
  </IconButton>
);

export default BackChevron;
